import * as React from "react";
import {
  Badge,
  Body1,
  Divider,
  Image,
  Link,
  makeStyles,
  shorthands,
  Subtitle2,
  tokens,
} from "@fluentui/react-components";
import { CalendarLtrRegular, LinkRegular, PeopleTeamRegular } from "@fluentui/react-icons";
import { envUtils } from "../../../utils/envUtils";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "8px 15px 20px 15px",
  },
  logo: {
    height: "30px",
    alignSelf: "flex-start",
  },
  intro: {
    color: tokens.colorNeutralForeground2,
    lineHeight: "20px",
  },
  featureCard: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "16px",
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: tokens.borderRadiusLarge,
    ...shorthands.border("1px", "solid", tokens.colorNeutralStroke2),
  },
  featureHeading: {
    color: tokens.colorNeutralForeground1,
  },
  featureRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
  },
  featureIcon: {
    flexShrink: 0,
    fontSize: "20px",
    color: tokens.colorBrandForeground1,
    marginTop: "1px",
  },
  featureText: {
    color: tokens.colorNeutralForeground2,
    lineHeight: "19px",
  },
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
  },
});

const FEATURES = [
  {
    icon: <CalendarLtrRegular />,
    text: "Schedule CADchat meetings right from your Outlook calendar.",
  },
  {
    icon: <LinkRegular />,
    text: "Join links are added to your invites automatically.",
  },
  {
    icon: <PeopleTeamRegular />,
    text: "Keep your team in sync without switching between tools.",
  },
];

export const About = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Body1 className={styles.intro}>
        <Link href="https://cadchat.com" target="_blank" rel="noopener noreferrer">
          CADchat
        </Link>{" "}
        is meeting software for product teams, designed to ensure meetings go beyond just talk. It
        helps teams collaborate effectively, make decisions faster, and keep projects moving.
      </Body1>

      <div className={styles.featureCard}>
        <Subtitle2 className={styles.featureHeading}>With the calendar add-in</Subtitle2>
        {FEATURES.map((feature) => (
          <div key={feature.text} className={styles.featureRow}>
            <span className={styles.featureIcon}>{feature.icon}</span>
            <Body1 className={styles.featureText}>{feature.text}</Body1>
          </div>
        ))}
      </div>

      <Divider />

      <div className={styles.footer}>
        <Link href="https://cadchat.com" target="_blank" rel="noopener noreferrer">
          Visit cadchat.com
        </Link>
        {envUtils.VERSION_NUMBER ? (
          <Badge appearance="tint" color="informative">
            Version {envUtils.VERSION_NUMBER}
          </Badge>
        ) : null}
      </div>
    </div>
  );
};
